<template>
  <el-progress :percentage="percentage" :color="customColors" :stroke-width="18" :text-inside="true"
    :format="format"></el-progress>
</template>

<script>
// -- import * as _ from "lodash-es"
export default {
  name: "BaseProgress",
  data() {
    return {
      percentage: 0,
      customColor: '#409eff',
      customColors: [
        { color: '#f56c6c', percentage: 20 },
        { color: '#e6a23c', percentage: 40 },
        { color: '#5cb87a', percentage: 60 },
        { color: '#1989fa', percentage: 80 },
        { color: '#67C23A', percentage: 100 },
        // { color: '#6f7ad3', percentage: 100 },
      ]
    }
  },
  methods: {
    // customColorMethod(percentage) {
    //   if (percentage < 30) {
    //     return '#909399';
    //   } else if (percentage < 70) {
    //     return '#e6a23c';
    //   } else {
    //     return '#67c23a';
    //   }
    // },
    increase(step) {
      this.percentage += step
      console.log(this.percentage)
      if (this.percentage > 100) {
        this.percentage = 100
      }
      this.$forceUpdate()
    },
    decrease() {
      this.percentage -= 5
      if (this.percentage < 0) {
        this.percentage = 0
      }
    },
    format() {
      return _.round(this.percentage, 0) + "%"
    }
  }
}
</script>
